/**
 * Super Cut upload details.
 */
enum SuperCutUpload {
    YouTube = 'CT_SUPER_CUT_UPLOAD_TYPE_YOUTUBE',
    YouTubeShorts = 'CT_SUPER_CUT_UPLOAD_TYPE_YOUTUBE_SHORTS',
    Vimeo = 'CT_SUPER_CUT_UPLOAD_TYPE_VIMEO',
    FileUpload = 'CT_SUPER_CUT_UPLOAD_TYPE_FILE_UPLOAD',
    InstagramTV = 'CT_SUPER_CUT_UPLOAD_TYPE_INSTAGRAM_TV',
    Unknown = 'CT_SUPER_CUT_UPLOAD_TYPE_UNKOWN',
}

namespace SuperCutUpload {
    /**
     * Returns a normalized upload type constant since dvr-app returns a charfield.
     */
    export function getNormalizedUploadType(uploadType: string): SuperCutUpload {
        switch (uploadType.toLowerCase()) {
            case 'igtv':
                return SuperCutUpload.InstagramTV
            case 'youtube':
                return SuperCutUpload.YouTube
            case 'youtube shorts':
                return SuperCutUpload.YouTubeShorts
            case 'file upload':
                return SuperCutUpload.FileUpload
            case 'vimeo':
                return SuperCutUpload.Vimeo
            default:
                return SuperCutUpload.Unknown
        }
    }

    /**
     * Returns the upload type's title text for display.
     */
    export function title(uploadType: SuperCutUpload): string {
        switch (uploadType) {
            case SuperCutUpload.InstagramTV:
                return 'IGTV'
            case SuperCutUpload.Vimeo:
                return 'Vimeo'
            case SuperCutUpload.YouTube:
                return 'YouTube'
            case SuperCutUpload.YouTubeShorts:
                return 'YouTube Shorts'
            case SuperCutUpload.FileUpload:
                return 'File Upload'
            case SuperCutUpload.Unknown:
                return 'Unknown'
        }
    }

    export function icon(uploadType: SuperCutUpload): string {
        switch (uploadType) {
            case SuperCutUpload.InstagramTV:
                return 'ss-social ss-instagram'
            case SuperCutUpload.Vimeo:
                return 'ss-social ss-vimeo'
            case SuperCutUpload.YouTube:
                return 'ss-social ss-youtube'
            case SuperCutUpload.YouTubeShorts:
                return 'youtube-shorts-icon'
            case SuperCutUpload.FileUpload:
                return 'ss-upload'
            case SuperCutUpload.Unknown:
                return 'ss-help'
        }
    }
}

export default SuperCutUpload
